import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminService } from 'src/app/services/admin.service';
import { Subscriber } from 'rxjs';
import { TranslateService } from 'src/app/shared/lang/translate.service';

@Component({
  selector: 'app-withrawal-report',
  templateUrl: './withrawal-report.component.html',
  styleUrls: ['./withrawal-report.component.css']
})
export class WithrawalReportComponent implements OnInit, OnDestroy {
  totalRent: number = 0;
  totalOccupiedRent: number = 0;
  totalCollectedRent: number = 0;
  totalExpenses: number = 0;
  @Input() model: any;
  @Input() type: any;
  @Input() filter: any;
  @Input() pagination: any;
  @Input() selectedMonths: any;
  date: Date = new Date();

  subscription = new Subscriber();

  constructor(private router: Router,
    public translate:TranslateService,
    private activatedRoute: ActivatedRoute, public admin: AdminService) { }

  ngOnInit() {
  }


  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
